import { ModalClose } from "@/components/_primitives/Modal/ModalClose/ModalClose";
import ModalContent from "@/components/_primitives/Modal/ModalContent/ModalContent";
import ModalOverlay from "@/components/_primitives/Modal/ModalOverlay/ModalOverlay";
import ModalPortal from "@/components/_primitives/Modal/ModalPortal/ModalPortal";
import ModalRoot from "@/components/_primitives/Modal/ModalRoot/ModalRoot";
import React from "react";
import { FormModal } from "../FormModal/FormModal";
import { EquipmentType, RecipeType } from "@/types/baseTypes";
import { useAppContext } from "@/context/AppContext";
import { SortedCategoriesType } from "@/utils/rezeptAPI/getRecipeFilterOptions";

function LoginAreaFormWrapper({
  children,
  recipeDetails,
  filterOptions,
  equipmentList,
}: {
  children: React.ReactNode;
  recipeDetails?: RecipeType;
  filterOptions?: SortedCategoriesType | null;
  equipmentList?: EquipmentType[];
}) {
  const { formModalType } = useAppContext();

  return (
    <ModalRoot>
      {children}
      <ModalPortal>
        <ModalOverlay />
        <ModalContent>
          {formModalType !== "recipe-filter" && <ModalClose />}
          <FormModal
            recipeDetails={recipeDetails}
            filterOptions={filterOptions ?? null}
            equipmentList={equipmentList}
          />
        </ModalContent>
      </ModalPortal>
    </ModalRoot>
  );
}

export default LoginAreaFormWrapper;
